/* eslint-disable jsx-a11y/label-has-for */
import React, { Component } from 'react';
import {
  ListGroup,
  ListGroupItem,
} from 'react-bootstrap';
import PropTypes from 'prop-types';
import exact from 'prop-types-exact';

import './SubmissionList.css';
import {
  formatMonthDay,
  toCentralTime,
  formatTime,
} from '../../utils';
/*
This maps submission states from the API to states used to render colors
 */
const submissionStateStyleMap = new Map([
  /* TODO: Remove this mapping when doing with debugging */
  ['processed', 'success'],
  // ['unprocessed', 'info'],
  ['rejected', 'danger'],
]);

export const MessageDisplay = ({ message }) => {
  return (
    <div>
      {message}
    </div>
  );
};
MessageDisplay.propTypes = exact({
  message: PropTypes.string.isRequired,
});

const defaultProps = {
  selectedItem: {},
  items: [],
};

/* eslint-disable react/prefer-stateless-function */
export class SubmissionList extends Component {
  render() {
    const submissionItems = this.props.items;
    const isItemSelected = (this.props.selectedItem !== null);

    if ((this.props.items || []).length === 0) {
      return (
        <div className="panel panel-default">
          <div className="panel-body" style={{ textAlign: 'center' }}>
            <h4>Empty</h4>
            <p className="text-muted">No Submission Items are available for processing</p>
          </div>
        </div>
      );
    }
    return (
      <div>
        <ListGroup className="submissionList-scroll-bar">
          {submissionItems.map((item) => {
            /* TODO: Remove this mapping when doing with debugging */
            const submissionStateStyle = submissionStateStyleMap.get(item.state);
            const dateValue = formatMonthDay(toCentralTime(item.submission.submitted_at.iso8601));
            const timeValue = formatTime(item.submission.submitted_at.iso8601);
            // NOTE: Safeguard against nothing selected
            return (
              <ListGroupItem
                className={isItemSelected && (this.props.selectedItem.id === item.id) ? 'active' : ''}
                bsStyle={submissionStateStyle}
                key={item.id}
                onClick={(e) => {
                  return this.props.onSelect(item);
                }}
                header={`${item.submission.submitted_by.firstname} ${item.submission.submitted_by.lastname}`}
              >
                {`${dateValue} ${timeValue}`}
              </ListGroupItem>
            );
          })}
        </ListGroup>
      </div>
    );
  }
}

SubmissionList.propTypes = exact({
  /* eslint-disable react/forbid-prop-types */
  onSelect: PropTypes.func.isRequired,
  items: PropTypes.array,
  selectedItem: PropTypes.object,
});

SubmissionList.defaultProps = defaultProps;

export default SubmissionList;
